<template>
  <div v-if="isShow()" id="change-deleted">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <span class="col">
            <button class="btn btn-danger w-100" @click="changeStatus()">
              <span class="spinner-border spinner-border-sm me-2" v-if="isPending()"></span>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-player-track-next"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 5v14l8 -7l-8 -7" /><path d="M14 5v14l8 -7l-8 -7" /></svg>
              Сменить только статус
            </button>
          </span>
          <span class="col-auto align-self-center info">
            <Popper placement="top" arrow>
              <template #default>
                <span class="form-help ms-1">?</span>
              </template>
              <template #content>
                <p>Если по какой-то причине пост не сменил статус, но в Telegram канале был удален, то можно сменить только статус.</p>
              </template>
            </Popper>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {defineComponent, onMounted, reactive, ref} from "vue"
import Popper from "@/plugins/popper"
import Api from "./services/Api"
import Notify from "@/services/Notify"

export default defineComponent({
  name: "ChangeDeleted",
  components: {
    Popper,
  },
  props: {
    payload: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, {emit}) {
    let show = ref(false)
    let pending = ref(false)

    const fields = reactive({
      post_id: null,
    })

    onMounted(async () => {
      updateFields(props.payload)

      markUnshow()
      markShow()
    })

    function updateFields(query) {
      fields.post_id = query.post_id
    }

    function markShow() {
      show.value = true
    }

    function markUnshow() {
      show.value = false
    }

    function isShow() {
      return show.value === true
    }

    async function changeStatus() {
      if (confirm("Вы действительно хотите сменить статус на \"Удалено\"?")) {
        markPending()
        try {
          await Api.changeDeleted(fields.post_id)
          Notify.success("Поставлена задача на изменения статуса")
          pushEvent()
        } catch {
          Notify.error("Ошибка при изменении статуса")
        }
        markUnpending()
      }
    }

    function isPending() {
      return pending.value === true
    }

    function markPending() {
      return pending.value = true
    }

    function markUnpending() {
      return pending.value = false
    }

    function pushEvent() {
      emit("onChange")
    }

    return {
      isShow,
      fields,
      changeStatus,
      isPending,
    }
  }
})
</script>

<style scoped src="./css/style.css"></style>
